import { IconBase, IconComponent } from './BaseIcon';

export const Rotate: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M23.33 8.1a10.92 10.92 0 0 0-15.44 0l-.26.26V5.9h-2v5.94h6v-2H9l.32-.32a8.92 8.92 0 1 1 0 12.61l-1.43 1.41A10.92 10.92 0 0 0 23.33 8.1z" />
  </IconBase>
);
